import { IAdmin, IAdminSearch, ILogin, IPassword } from "@interfaces";
import axiosClient from "./axiosClient";

export const authApi = {
  login: (params: ILogin) => {
    const url = "/admin/login";
    return axiosClient.post(url, params);
  },
  clinicLogin: (params: ILogin) => {
    const url = "/clinic/login";
    return axiosClient.post(url, params);
  },
  create: (params: IAdmin) => {
    const url = "/admin/create";
    return axiosClient.post(url, params);
  },
  detail: (id: string) => {
    const url = `/admin/get/${id}`;
    return axiosClient.get(url);
  },
  admins: (params: IAdminSearch) => {
    const url = `/admin/get`;
    return axiosClient.get(url, { params });
  },
  update: (params: IAdmin, id: string) => {
    const url = `/admin/update/${id}`;
    return axiosClient.put(url, params);
  },
  changePassword: (params: IPassword) => {
    const url = `/clinic/change-password`;
    return axiosClient.post(url, params);
  },
  refresh: () => {
    const url = `/refresh-token`;
    return axiosClient.get(url);
  },
};
